import React, { useContext, useEffect, useState } from "react";
import { Space, Flex, Input, Button, Divider, Empty, App } from 'antd'
import { Helmet } from "react-helmet"
import { useNavigate, useParams } from "react-router-dom"
import { FaChevronRight, FaSearch } from "react-icons/fa";
import _ from "lodash";
import dayjs from "dayjs";
import { API, Variable } from "../../resources/constants"
import language from "../../resources/languages/en_US"

// Commons
import { getTenders } from '../../commons/tender'

// Interfaces
import { Ask as AskType } from "../../interfaces/pages/opportunities"
import { AxiosError } from "../../interfaces/axios";

// Contexts
import AxiosContext from "../../contexts/axios";
import GlobalContext from "../../contexts/global";

const { TENDER_CHAT_ALL } = API
const { PostedDate } = Variable
const { App: { title }, Pages: { AskHistory: AskHistoryLanguage }, Share, Validation, Message: MessageLanguage, Enum: EnumLanguage } = language

export default function AskHistory() {

    const { axios } = useContext(AxiosContext)
    const { dispatch } = useContext(GlobalContext)
    const [, forceUpdate] = useState({})
    const [asks, setAsks] = useState<AskType[]>([])
    const [loadingAsks, setLoadingAsks] = useState<boolean>(false)
    const [searchValue, setSearchValue] = useState<string>('')
    const { source } = useParams()
    const navigate = useNavigate()
    const { message, modal } = App.useApp()

    useEffect(() => {
        // To disable submit button at the beginning.
        forceUpdate({})
        initialAPI().then(response => response)
    }, [])

    useEffect(() => {
        setSearchValue('');
        initialAPI().then(response => response)
    }, [source])

    const initialAPI = async () => {
        await getAsks('', true);
    }

    const getAsks = async (title: string, loading: boolean = false): Promise<AskType[]> => {
        setLoadingAsks(true);
        return axios.post(TENDER_CHAT_ALL, { type: source, title }, { params: { source, loading } }).then((response: { data: AskType[] }) => {
            const { data: asks } = response;
            setAsks(asks);
            setLoadingAsks(false);
            return asks;
        }).catch((error: AxiosError) => {
            const { response: { data } } = error;
            setAsks([]);
            setLoadingAsks(false);
            // @ts-ignore
            message.error(MessageLanguage[data.message]||data.message).then(response => response )
        })
    }

    const navigateTender = (tenderId: string, tenderType: string) => getTenders(axios, { expired: true, eligible: true }, PostedDate, tenderType, dispatch).then(() => navigate({
        pathname: '/opportunities/tender/' + tenderId,
        search: '?source=' + tenderType,
    }))

    return (
        <div className={'ask-history'}>
            <Helmet>
                <title>
                    {
                        // @ts-ignore
                        `${title} - ${AskHistoryLanguage.title} ${EnumLanguage.Source[source]}`
                    }
                </title>
            </Helmet>
            <Space direction={'vertical'} size={50} style={{width:'100%'}}>
                <Space className={'buttons-left'} style={{width:'100%'}}>
                    <Button
                        type={'text'}
                        icon={<FaChevronRight size={16} />}
                        style={{cursor:'default'}}
                        className={'button-grey'}
                    >
                        {
                            AskHistoryLanguage.title
                        }
                    </Button>
                    <Button type={'primary'} icon={<FaChevronRight size={16} />} onClick={() => navigate({
                        pathname: '/opportunities/ask-history/' + source,
                    })} >
                        {
                            // @ts-ignore
                            EnumLanguage.Source[source]
                        }
                    </Button>
                </Space>
                <Space direction={'vertical'} size={15} style={{width:'100%'}} className={'ask-search'}>
                    <div className={'search'}>
                        <Input
                            value={searchValue}
                            placeholder={AskHistoryLanguage.search}
                            size="large"
                            prefix={
                                <Button
                                    type={'text'}
                                    icon={<FaSearch size={22} />}
                                    loading={loadingAsks}
                                    style={{cursor:'default'}}
                                />
                            }
                            onChange={async ({ target: { value }}) =>  {
                                setSearchValue(value)
                                await getAsks(value)
                            }}
                        />
                        <Divider />
                    </div>
                    <Space direction={'vertical'} className={'asks'} size={2} style={{width:'100%'}}>
                        {
                            _.isEmpty(asks) ? <Empty description={Share.noAsk} /> : asks.map(({ id, title, description, tender, type, updatedAt}) => id && title && description && updatedAt && (
                                <Flex gap={10} className={'message'} style={{cursor: 'pointer'}} onClick={() => navigateTender(tender, type)}>
                                    <Space direction={'vertical'} size={2} style={{width:'100%'}}>
                                        <span className={'title'}>{title.substring(0,100)} ...</span>
                                        <span className={'description'}>{description.substring(0,100)} ...</span>
                                    </Space>
                                    <span className={'date'}>{dayjs(updatedAt).tz(process.env.REACT_APP_TZ).format('D MMMM')}</span>
                                </Flex>
                            ))
                        }
                    </Space>
                </Space>
            </Space>
        </div>
    )
}